import * as angular from "angular";
import {IController, ITimeoutService} from "angular";
import * as _ from "lodash";
import {RoutePanelModel} from "../../models/route-panel.model";
import {
  RoutesViewSettingsModel,
  RoutesViewSettingsRouteModel,
  RoutesViewSettingsRoutesModel
} from "../../models/routes-view-settings.model";
import {RouteModel} from "../../models/route.model";
import {RoutesFacadeService} from "../../../lean-planning/angular/services/routes-facade.service";
import {SiteFiltersType} from "../../../commons/types/site-filters.type";
import {
  DateRangeTimeFiltersService
} from "../../../commons/services/date-range-time-filters.service";
import {ViewFilterSettingsService} from "../../../commons/services/view-filter-settings.service";
import {ViewSettingsModel} from "../../../commons/models/view-settings.model";
import {GroupModel} from "../../../groups/models/group.model";
import {RouteStatusEnum} from "../../enums/route-status.enum";
import {RoutesViewMode} from "../../enums/routes-view-mode.enum";
import {ResizeService} from "../../../commons/services/resize-service.service";
import {RoutesService} from "../../services/routes-service.service";
import {LeanPlanningRequestsService} from "../../../lean-planning/services/plan-requests.factory";
import {
  LeanPlanningAlertsService
} from "../../../lean-planning/services/lean-planning-alerts.factory";
import {LeanPlanningService} from "../../../lean-planning/services/lean-planning-service.service";
import {CommonsDialogService} from "../../../commons/services/commons-dialog.service";
import {RouteRequestsService} from "../../services/routes-requests.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import {ViewSettingsService} from "../../../commons/services/view-settings-service.service";
import {Subscription} from "rxjs";
import {RoutesDialogService} from "../../services/routes-dialog-service.service";
import {SortType} from "../../../commons/types/sort.type";

export class RoutesPanelComponent implements IController {

  public RoutesViewMode = RoutesViewMode;

  index: any;
  panel: RoutePanelModel;
  viewMode: string;
  selectedRouteId?: string;
  selectedServiceIds: string[];
  visibleIds: any[];
  highlightedTask?: any;
  resourcesDropListIds?: string[];
  routesDropListIds?: string[];
  expandedRoutes: RouteModel[];
  panels: RoutePanelModel[];
  settings: RoutesViewSettingsModel
  ungroupedRouteIds: Set<string>;
  onPanelChange: Function;
  onSettingsChange: Function;
  onEditRoutes: Function;
  onAddTasksToRoute: Function;
  onToggleVisible: Function;
  onSelectRouteResource: Function;
  onAssignAndSelect: Function;
  onAssignToAttachedAgent: Function;
  onDeleteRoutes: Function;
  onMergeRoutes: Function;
  onResetRoutes: Function;
  onUpdateBranchesRoutes: Function;
  onExport: Function;
  onExportIntegration: Function;
  onHandleUnpackedServices: Function;
  onReoptimizeRoute: Function;
  onLockRoute: Function;
  onUnlockRoute: Function;
  onUpdateResource: Function;
  onUpdateLogisticsVehicleRoute: Function;
  onManageAssistants: Function;
  onChangeRouteColor: Function;
  onSelectServices: Function;
  onDrillDown: Function;
  onRouteResourcesAssignment: Function;
  onGroupedTaskToggle: Function;
  onAssociate: Function;
  onSplitByPackages: Function;

  sub: Subscription;

  public customTemplates: any;
  public routeStatusType: typeof RouteStatusEnum = RouteStatusEnum;
  public selectedQuickFilterId?: string;
  public selectedRoute?: any;
  public totals: any;
  public loading: boolean;

  public routes: RouteModel[];
  private pageName: string;
  public sortOptions: string[];
  public selectedIds: string[] = [];
  public selectedRoutes: RouteModel[] = [];
  public excludeMode: boolean;

  /* @ngInject */
  constructor(
    private routesFacadeService: RoutesFacadeService,
    private dateRangeTimeFiltersService: DateRangeTimeFiltersService,
    private viewFilterSettingsService: ViewFilterSettingsService,
    private viewSettingsService : ViewSettingsService,
    private $state,
    private $groups,
    private commonsConstants,
    private commonsDialogService: CommonsDialogService,
    private confirmDialogService: ConfirmDialogService,
    private $timeout: ITimeoutService,
    private resizeService: ResizeService,
    private routesService: RoutesService,
    private routesDialogService: RoutesDialogService,
    private leanPlanningService: LeanPlanningService,
    private leanPlanningRequestsService: LeanPlanningRequestsService,
    private leanPlanningAlertsService: LeanPlanningAlertsService,
    private routeRequestsService: RouteRequestsService,
    private $planningRoutes
  ) {
    this.customTemplates = this.dateRangeTimeFiltersService.getDeliveriesCustomTemplates();
  }

  $onInit() {
    this.pageName = this.$state.current.name;
    this.sortOptions = [
      'totalWeight',
      'totalVolume',
      'resourceName',
      'taskCount',
      'pickupBundledStops',
      'dropoffBundledStops',
      'operationBundledStops'
    ];
    // const quickActiveFilter = this.viewFilterSettingsService.getActiveQuickFilter(this.$state.current.name);

    const defaults = {
      routeIds: [],
      routesStatus: RouteStatusEnum.Unassigned,
      // customTemplates: this.dateRangeTimeFiltersService.getDeliveriesCustomTemplates(),
      excludeIdsMap: {
        [SiteFiltersType.branchIds]: []
      },
      queryString: undefined,
      range: this.dateRangeTimeFiltersService.today(),
      // tags: this.project ? [this.project.id] : undefined,
      bringozFilters: {
        branchIds: [],
        depotIds: [],
        groupIds: [],
        serviceAreaIds: [],
        agentIds: [],
        agentSkills: [],
        resourceIds: [],
        agentScheduleIds: [],
        tags: [],
        resourceTags: [],
        vehicleTypeIds: [],
        relationTypes: []
      },
      includeFilters: [
        SiteFiltersType.agentIds,
        SiteFiltersType.agentSkills,
        SiteFiltersType.serviceAreaIds,
        SiteFiltersType.branchIds,
        SiteFiltersType.depotIds,
        SiteFiltersType.groupIds,
        SiteFiltersType.resourceIds,
        SiteFiltersType.agentScheduleIds,
        SiteFiltersType.tags,
        SiteFiltersType.resourceTags,
        SiteFiltersType.vehicleTypeIds,
        SiteFiltersType.relationTypes
      ]
    }

    this.panel.routesFilters = {
      ...defaults,
      ...this.panel.routesFilters,
      includeFilters: defaults.includeFilters,
      excludeIdsMap: {
        ...defaults.excludeIdsMap,
        ...(this.panel.routesFilters?.excludeIdsMap ?? {})
      },
      bringozFilters: {
        ...defaults.bringozFilters,
        ...(this.panel.routesFilters?.bringozFilters ?? {})
      },
    };

    this._setTotals();
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.selectedRouteId) {
      if (this.selectedRouteId) {
        this._selectRoute(this.selectedRouteId);
      } else {
        this.selectedRoute = undefined;
      }
    }
  }

  onStatusChange(status?: RouteStatusEnum) {
    this.panel.routesFilters.routesStatus = status;
    this.selectedRoute = undefined;
    this.selectedIds = [];
    this.selectedRoutes = [];
    this.excludeMode = false;

    this._setTotals();

    this.onPanelChange({panel: this.panel});
  }

  onQuickFilterSelect(quickFilter: ViewSettingsModel) {
    if (!!quickFilter) {
      if (quickFilter.settings.groupIds?.length) {
        this.$groups().$asyncValues(quickFilter.settings.groupIds)
          .then((groups) => {
            let groupsBranchIds = [];
            groups.forEach((g: GroupModel) => {
              if (g.branchIds?.length) {
                groupsBranchIds = groupsBranchIds.concat(g.branchIds)
              }
            });
            this.panel.routesFilters.excludeIdsMap[SiteFiltersType.branchIds] = groupsBranchIds;
            quickFilter.settings[SiteFiltersType.branchIds] = _.uniq(groupsBranchIds);
            this.onFiltersChange(quickFilter.settings, quickFilter);
          })
      } else {
        this.onFiltersChange(quickFilter.settings, quickFilter);
      }
    } else {
      const filters = angular.copy(this.panel.routesFilters.bringozFilters);
      _.forOwn(filters, (value, key) => {
        filters[key] = _.isArray(value) ? [] : undefined;
      })
      this.onFiltersChange(filters);
    }
  }


  onRangeChanged(range) {
    if (range &&
      (!_.isEqual(range.dateStart, this.panel.routesFilters.range.dateStart) ||
        !_.isEqual(range.dateEnd, this.panel.routesFilters.range.dateEnd))) {

      if (!!this.panel.routesFilters.routeIds) {
        this.panel.routesFilters.routeIds = undefined;
      }

      const dateRangeTemplate = this.dateRangeTimeFiltersService.getDateRangeFilterByType(range.type);

      // Set Routes Range
      this.panel.routesFilters.range = dateRangeTemplate || range;

      // Set Also Services Range
      if (this.panel.servicesFilters) {
        this.panel.servicesFilters.range = dateRangeTemplate || range;
      }

      // Set Also Resources Range
      if (this.panel.resourcesFilters) {
        this.panel.resourcesFilters.range = dateRangeTemplate || range;
      }

      this.selectedRoute = undefined;
      this._setTotals();

      this.onPanelChange({panel: this.panel});
    }
  }

  onFiltersChange(filters, selectedQuickFilter?) {
    this.selectedQuickFilterId = selectedQuickFilter?.id;
    this.viewFilterSettingsService.setActiveQuickFilter(selectedQuickFilter, this.pageName);

    this.panel.routesFilters.bringozFilters = angular.copy(filters);

    if (!!this.panel.routesFilters.routeIds) {
      this.panel.routesFilters.routeIds = undefined;
    }

    this.selectedRoute = undefined;
    this.onPanelChange({panel: this.panel});

    this._setTotals();
  }

  onSettingsBeforeChange(routesSettings: RoutesViewSettingsRoutesModel, tasksSettings: RoutesViewSettingsRouteModel) {
    const settings = angular.copy(this.settings);
    settings.routes = routesSettings;
    settings.route = tasksSettings;

    this.onSettingsChange({settings: settings});
  }

  onQueryChanged(query) {
    this.panel.routesFilters.queryString = query;
    this.onPanelChange({panel: this.panel});

    this._setTotals();
  }

  onRouteSelect(routeId: string | undefined) {
    this.panel.selectedRouteId = routeId;
    if (!routeId) {
      this.selectedRoute = undefined;
    }
    this.onPanelChange({panel: this.panel});
  }

  onLockRouteChange(id: string, locked: boolean) {
    if (locked) {
      this.onLockRoute({id: id});
    } else {
      this.onUnlockRoute({id: id});
    }
  }

  onToggleSelectAll() {
    const total = this.totals?.[this.panel.routesFilters.routesStatus || 'Total'] || 0;
    const isAllSelected = this.excludeMode ? (this.selectedIds.length === 0 && total > 0) : (this.selectedIds.length === total && total > 0);

    if (isAllSelected) {
      this.selectedIds = [];
      this.selectedRoutes = [];
      this.excludeMode = false;
    } else {
      this.selectedIds = [];
      this.selectedRoutes = [];
      this.excludeMode = true;
    }
  }

  onToggleSelectRoute(route: RouteModel, isSelected: boolean) {
    this.selectedIds = isSelected ? this.selectedIds.concat([route.id]) :
      this.selectedIds.filter((id) => {
        return id !== route.id;
      });

    this.selectedRoutes = isSelected ? this.selectedRoutes.concat([route]) :
      this.selectedRoutes.filter((r: RouteModel) => {
        return r.id !== route.id;
      });
  }

  onMoveTaskAction(payload: {serviceId, fromRouteId, toRouteId, fromOrderedIds, toOrderedIds, isBetweenDays, toDate}) {
    this.onEditRoutes({
      serviceId: payload.serviceId,
      fromRouteId: payload.fromRouteId,
      toRouteId: payload.toRouteId,
      fromOrderedIds: payload.fromOrderedIds,
      toOrderedIds: payload.toOrderedIds,
      isBetweenDays: payload.isBetweenDays,
      toDate: payload.toDate
    })
  }

  // onResetRoutes(ids) {
  //   this.confirmDialogService.confirm('Reset Routes', 'Are you sure you want to reset?')
  //     .then(() => {
  //       this._resetRoutes(ids);
  //     })
  //     .catch(() => {
  //       // this.$log.info('Dialog Closed');
  //     })
  // }
  //
  // onDeleteRoutes(ids) {
  //   this.confirmDialogService.confirm('Delete Routes', 'Are you sure you want to delete these routes?')
  //     .then(() => {
  //       // this._deleteRoutes(ids, this.excludeMode);
  //       this._deleteRoutes(ids);
  //     })
  //     .catch(() => {
  //       // this.$log.info('Dialog Closed');
  //     })
  // }
  //
  // onAssignAndSelect(ids: string[], ev?) {
  //   this.leanPlanningDialogService.manualAssignRoutes(ev, ids)
  //     .then((payload) => {
  //       this._assignRoutes(ids, payload.agentId, payload.assignServices);
  //     })
  // }
  //
  // onAssignToAttachedAgent(ids) {
  //   this.routeRequestsService.assignRoutesToAttachedAgents(
  //     this.excludeMode ? [] : this.selectedIds,
  //     this.panel.routesFilters.bringozFilters.branchIds,
  //     this.excludeMode ? this.selectedIds : [],
  //     this.panel.routesFilters.range.dateStart,
  //     this.panel.routesFilters.range.dateEnd,
  //     this.panel.routesFilters.bringozFilters.agentSkills,
  //     this.panel.routesFilters.queryString,
  //     this.panel.routesFilters.bringozFilters.serviceAreaIds,
  //     this.panel.routesFilters.routesStatus,
  //     this.panel.routesFilters.bringozFilters.resourceIds.concat(this.panel.routesFilters.bringozFilters.agentScheduleIds),
  //     this.panel.routesFilters.bringozFilters.tags
  //   )
  //     .then(() => {
  //       this.leanPlanningAlertsService.assignSuccess();
  //     })
  //     .catch((error) => {
  //       this.leanPlanningAlertsService.assignError();
  //       // this.$log.error('Failed to assign route to driver @planningRoutesTable@onAssignRoute', error)
  //     })
  //     .finally(() => {
  //       // this.loading = false;
  //       this.selectedIds = [];
  //     })
  // }
  //
  // onHandleUnpackedDeliveries(route, services, event?) {
  //   this.leanPlanningDialogService.handleUnpackedServices(services, event)
  //     .then((serviceIdsToRemove) => {
  //       // this.loading = true;
  //       return this.leanPlanningRequestsService.removeDeliveryFromRoute(serviceIdsToRemove,
  //         route.rid)
  //     })
  //     .then(() => {
  //       this.leanPlanningAlertsService.removeUnpackedSuccess();
  //     })
  //     .catch((error) => {
  //       if (error) {
  //         this.leanPlanningAlertsService.removeUnpackedError();
  //         // this.$log.error(
  //         //   'Failed to remove unpacked deliveries @planningRoutes@onHandleUnpackedDeliveries',
  //         //   error);
  //       }
  //     })
  //     .finally(() => {
  //       // this.loading = false;
  //     });
  // }

  onShowRouteTimeline(routeId: string, event) {
    this.routesDialogService.routeTimeline(routeId, event);
  }

  onReoptimizedRoute(routeId) {
    // this.optimizing = true;
    this.leanPlanningRequestsService.optimizeRoute(routeId)
      .then((optimizedRoute) => {
        // this.route = optimizedRoute;
        this.leanPlanningAlertsService.reOptimizeSuccess();
      })
      .catch((error) => {
        this.leanPlanningAlertsService.reOptimizeError();
        // this.$log.error('Failed to Optimize route @planningRoute@onRecalcRoute', error);
      })
      .finally(() => {
        // this.optimizing = false;
      })
  }

  onResetRoutesSelection() {
    this.selectedIds = [];
    this.selectedRoutes = [];
    this.excludeMode = false;
  }

  private _setTotals() {
    this.totals = undefined;
    this.routesService.getRoutesStatusesTotals(
      this.panel.routesFilters.routeIds,
      this.panel.routesFilters.range.dateStart,
      this.panel.routesFilters.range.dateEnd,
      this.panel.routesFilters.bringozFilters.branchIds,
      this.panel.routesFilters.bringozFilters.serviceAreaIds,
      this.panel.routesFilters.queryString,
      this.panel.routesFilters.bringozFilters.tags,
      this.panel.routesFilters.bringozFilters.agentIds,
      this.panel.routesFilters.bringozFilters.agentSkills,
      this.panel.routesFilters.bringozFilters.resourceIds.concat(this.panel.routesFilters.bringozFilters.agentScheduleIds),
      undefined,
      this.panel.routesFilters.bringozFilters.depotIds,
      this.panel.routesFilters.bringozFilters.resourceTags,
      this.panel.routesFilters.bringozFilters.vehicleTypeIds,
      this.panel.routesFilters.bringozFilters.relationTypes
    ).then((totals) => {
      this.totals = {};

      _.forOwn(totals, (value, key) => {
        this.totals[this._capitalizeFirst(key)] = value;
      });

      // this.totalSelectedRoutesCount = !!this.filterConfig.bringozFilters.routeStatuses?.length ? _.reduce(this.filterConfig.bringozFilters.routeStatuses, (sum, n) => {
      //   return sum + (this.totals[n.toLowerCase()] || 0);
      // }, 0) : this.totals.total;
    })
  }

  private _capitalizeFirst(str: string): string {
    if (!str) return str; // handle empty string
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  private _selectRoute(routeId: string) {
    if (!!routeId) {
      const query = {
        expandServices: false,
        expandTasks: false,
        expandTasksExt: true
      }
      this.loading = true;
      this.$planningRoutes(routeId).$instantGet(query)
        .then((route) => {
          this.selectedRoute = route;
        })
        .catch(() => {
          this.leanPlanningAlertsService.getRouteError();
          this.onRouteSelect(undefined);
        })
        .finally(() => {
          this.loading = false;
        })
    } else {
      this.selectedRoute = undefined;
      this.$timeout(100).then(() => {
        this.resizeService.resize();
      })
    }
  }

  private _updateRoute(route) {
    this.routesService.updateRoute(route);
  }

  handleSortingChange(sortBy: string, sortType: SortType) {
    const panelCopy = angular.copy(this.panel);
    panelCopy.routesFilters.sortBy = sortBy;
    panelCopy.routesFilters.sortType = sortType;
    this.onPanelChange({panel: panelCopy});
  }
}

angular
  .module('bringoz.admin.routes')
  .component('routesPanel', {
    bindings: {
      index: '<',
      panel: '<',
      viewMode: '<',
      selectedRouteId: '<?',
      selectedServiceIds: '<',
      visibleIds: '<',
      highlightedTask: '<?',
      resourcesDropListIds: '<?',
      routesDropListIds: '<?',
      expandedRoutes: '<',
      panels: '<',
      settings: '<',
      ungroupedRouteIds: '<',
      onClose: '&?',
      onFloat: '&?',
      onMinimize: '&?',
      onPanelChange: '&',
      onSettingsChange: '&',
      onEditRoutes: '&',
      onAddTasksToRoute: '&',
      onToggleVisible: '&',
      onSelectRouteResource: '&',
      onAssignAndSelect: '&',
      onAssignToAttachedAgent: '&',
      onDeleteRoutes: '&',
      onMergeRoutes: '&',
      onResetRoutes: '&',
      onUpdateBranchesRoutes: '&',
      onExport: '&',
      onExportIntegration: '&',
      onHandleUnpackedServices: '&',
      onReoptimizeRoute: '&',
      onLockRoute: '&',
      onUnlockRoute: '&',
      onUpdateResource: '&',
      onUpdateLogisticsVehicleRoute: '&',
      onManageAssistants: '&',
      onChangeRouteColor: '&',
      onSelectServices: '&',
      onRoutesDropListIdsChange: '&',
      onDrillDown: '&',
      onSortingChange: '&',
      onRouteResourcesAssignment: '&',
      onGroupedTaskToggle: '&',
      onAssociate: '&',
      onSplitByPackages: '&'
    },
    template: require('./routes-panel.html').default,
    controller: RoutesPanelComponent
  });

